import React from 'react'

import { 
    Table,
    Checkbox
} from 'antd'

import { _postToggleCreditPaymentDNS } from '../../services'

class NotifiedUsersTable extends React.Component{
    
    render(){
    
        const columns = [{
            title: 'Name',
            dataIndex: 'name'
        }, {
            title: 'Email',
            dataIndex: 'email'
        },{
            title: 'Notify',
            render:(user)=>{
                return(
                    <Checkbox
                        onChange={()=>this.handleDNS(user._id)}
                        defaultChecked={!user.doNotSend}
                    />
                )
            }
        }]

        return(
            <Table
                dataSource={this.props.users}
                columns={columns}
            />
        )
    }

    handleDNS = (userId) => {
        
        _postToggleCreditPaymentDNS({paymentId: this.props.paymentId, userId})
    }
}

export default NotifiedUsersTable


// WEBPACK FOOTER //
// ./src/components/credit-payment/notified-users-table.js